import React, { useEffect, useState } from 'react';
import { ClientService } from '../../../../services/ClientService';
import { Form, Spinner, Card, Tabs, Tab, Row, Col, Accordion, Button, OverlayTrigger, Alert, Tooltip, Dropdown, Badge, NavDropdown, Nav } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import ErrorManager from "../../../error-manager/ErrorManager";
import { isDark, granted } from '../../../../helper/Helper'
import MdReader from '../../../../components/md-reader/MdReader';
import Interlocuteurs from "./interlocuteurs/Interlocuteurs";
import Factures from "./factures/Factures";
import Abonnements from "./abonnements/Abonnements";
import Releve from "./releve/Releve";
import Proformas from "./proformas/Proformas";
import Adresses from "./adresses/Adresses";
import Tags from "./tags/Tags";
import { TarifService } from '../../../../services/TarifService';
import Reglements from './reglements/Reglements';
import { GlobalContext } from "../../../../services/GlobalProvider";
import Split from '../../../../components/split/Split';


const ClientDetails = (props) => {

    const { grants } = React.useContext(GlobalContext);

    let [client, setClient] = useState()
    const [getClientLoading, setGetClientLoading] = useState()
    const [tags, setTags] = useState([])
    let [openElement, setOpenElement] = useState()
    let [showReglementForm, setShowReglementForm] = useState(false)

    useEffect(() => {

        setClient()
        getClient()
        setOpenElement(props.openTab ? props.openTab : "client")

        if (props.openTab == "reglements") {
            setShowReglementForm(true)
        } else {
            setShowReglementForm(false)
        }

    }, [props.clientId]);

    function handleTabSelect(key) {
        setOpenElement(key)
    }

    function getClient() {
        setGetClientLoading(true)
        ClientService.getClient(props.folderId, props.clientId).then(res => {
            setClient(res.status == 200 ? res.data.data : { warning: res.statusText })
            setGetClientLoading(false)
            setTags(res?.data?.data?.tags)
        }).catch(error => {
            setClient({ error: error })
            setGetClientLoading(false)
        });
    }

    function tabChange() {
        getClient()
        props.onTabChange()
    }

    return (
        <div id="ClientDetails">

            {(!client && getClientLoading) &&
                <span className="hloader mt-3"></span>
            }

            {client?.warning &&
                <div className="d-inline-block w-100 mt-4">
                    <Alert variant="warning">
                        {client?.warning}
                    </Alert>
                </div>
            }

            {client?.error &&
                <div className="d-inline-block w-100 mt-4">
                    <ErrorManager error={client?.error} />
                </div>
            }

            {
                (client && !client.warning && !client.error) && (

                    <>
                        <div className="d-flex mb-4">
                            <div className="me-auto">
                                <h6 className="m-0">{client.nom}<span className="text-gray-500 ms-2">{client.code}</span></h6>
                                {tags?.length > 0 &&
                                    <span className="bubble-tags-container border mt-1">
                                        Tags :
                                        {tags.map(tag => (
                                            <span key={tag._id} className="bubble" style={{ backgroundColor: tag.couleur }}>
                                                <span style={{ backgroundColor: tag.couleur }} className={"label " + (isDark(tag.couleur) ? "text-dark" : "text-white")}>{tag.tag}</span>
                                            </span>
                                        ))}
                                    </span>
                                }
                            </div>
                            {props.elementActions.length > 0 &&
                                <Dropdown className="float-end ms-2 me-3">
                                    <OverlayTrigger
                                        placement="left"
                                        delay={{ show: 800 }}
                                        overlay={
                                            <Tooltip>
                                                Plus d'actions
                                            </Tooltip>
                                        }
                                    >
                                        <Dropdown.Toggle variant="secondary" className='no-btn-caret'>
                                            <i className="material-icons i-lg">more_horiz</i>
                                        </Dropdown.Toggle>
                                    </OverlayTrigger>
                                    <Dropdown.Menu>
                                        {props.elementActions.map((element) => (
                                            <Dropdown.Item key={element.title} onClick={() => props.setElementAction(element.action, client)}>{element.title}</Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            }
                        </div>

                        <div>

                            <Nav className="mb-3" variant="pills" defaultActiveKey={openElement} onSelect={handleTabSelect}>
                                <Nav.Item><Nav.Link eventKey="client">Client</Nav.Link></Nav.Item>
                                <Nav.Item><Nav.Link eventKey="tags">Tags</Nav.Link></Nav.Item>
                                <Nav.Item><Nav.Link eventKey="adresses">Adresses</Nav.Link></Nav.Item>
                                <Nav.Item><Nav.Link eventKey="interlocuteurs">Interlocuteurs</Nav.Link></Nav.Item>
                                {(granted(grants, "factures.consult") || granted(grants, "proformas.consult") || granted(grants, "abonnements.consult") || granted(grants, "reglements.consult")) &&
                                    <NavDropdown
                                        title={
                                            openElement == "factures" ? "Factures" :
                                                openElement == "proformas" ? "Proformas" :
                                                    openElement == "abonnements" ? "Abonnements" :
                                                        openElement == "reglements" ? "Règlements" :
                                                            "Facturation"
                                        }
                                        id="nav-dropdown"
                                        active={openElement == "factures" || openElement == "proformas" || openElement == "abonnements"  || openElement == "reglements"}
                                    >
                                        {granted(grants, "factures.consult") && <NavDropdown.Item eventKey="factures">Factures</NavDropdown.Item>}
                                        {granted(grants, "proformas.consult") && <NavDropdown.Item eventKey="proformas">Proformas</NavDropdown.Item>}
                                        {granted(grants, "abonnements.consult") && <NavDropdown.Item eventKey="abonnements">Abonnements</NavDropdown.Item>}
                                        {granted(grants, "reglements.consult") && <NavDropdown.Item eventKey="reglements">Règlements</NavDropdown.Item>}
                                    </NavDropdown>
                                }
                                <Nav.Item><Nav.Link eventKey="releve">Relevé</Nav.Link></Nav.Item>
                            </Nav>

                            <div className="light-v-scroll height-full-min-250 pe-2 tab-pane">
                                <Row>
                                    <Col >

                                        {openElement == "client" &&
                                            <>

                                                {client.bloquer == true &&
                                                    <div className="mb-3 p-3 bg-danger rounded">
                                                        <h6 className="text-white p-0 m-0">Client bloqué</h6>
                                                    </div>
                                                }

                                                <Accordion defaultActiveKey={['infos', 'conditions', 'infos_bancaires', 'localisation', 'echeance_comptable', 'observation']} alwaysOpen>
                                                    <Accordion.Item eventKey="infos" className="border-0 mb-3">
                                                        <Accordion.Header>Informations générales</Accordion.Header>
                                                        <Accordion.Body className="px-1">
                                                            <Split title="Code" border value={client.code} />
                                                            <Split title="Nom" border value={client.nom} />
                                                            <Split title="Profession" border value={client.profession} />
                                                            <Split title="Utilisateur" border value={client.user} />
                                                            <Split title="Ridet" border value={client.ridet} />
                                                            <Split title="Code APE" value={client.code_ape} />
                                                        </Accordion.Body>
                                                    </Accordion.Item>

                                                    <Accordion.Item eventKey="observation" className="border-0 mb-3">
                                                        <Accordion.Header>Observation</Accordion.Header>
                                                        <Accordion.Body className="px-1">
                                                            {client.observation &&
                                                                <MdReader mdData={client.observation} />
                                                            }
                                                        </Accordion.Body>
                                                    </Accordion.Item>

                                                    <Accordion.Item eventKey="conditions" className="border-0 mb-3">
                                                        <Accordion.Header>Conditions de vente</Accordion.Header>
                                                        <Accordion.Body className="px-1">
                                                            {/*                                                         <Split title="Tarif" border value={
                                                            tarifList.filter(t => t._id == client.tarif_id).map(tarif => (
                                                                <span key={tarif._id}>{tarif.code}</span>
                                                            ))
                                                        } /> */}
                                                            <Split title="Type" border value={client.type} />
                                                            <Split title="Interdire" border value={client.interdir} />
                                                            {client.exonerer_taxes == false &&
                                                                <Split title="Exonerer taxes" border value="Non" />
                                                            }
                                                            {client.exonerer_taxes == true &&
                                                                <Split title="Exonerer taxes" value="Oui" />
                                                            }
                                                            {client.exonerer_eco_participation == true &&
                                                                <Split title="Exonerer eco participation" border value="Oui" />
                                                            }
                                                            {client.exonerer_eco_participation == false &&
                                                                <Split title="Exonerer eco participation" border value="Non" />
                                                            }
                                                            <Split title="Taux de remise" border value={client.taux_remise + "%"} />
                                                            <Split title="Débit max" border value={client.debit_max} />
                                                            <Split title="Condition de paiement" border value={client.condition_paiement} />
                                                            {client?.tarif?._id && <Split title="Tarif" value={<a href={`/${props.folderId}/tarifs?tarifId=${client?.tarif?._id}`} target="_blank">{client?.tarif?.libelle}</a>} />}


                                                        </Accordion.Body>
                                                    </Accordion.Item>

                                                    <Accordion.Item eventKey="infos_bancaires" className="border-0 mb-3">
                                                        <Accordion.Header>Informations bancaires</Accordion.Header>
                                                        <Accordion.Body className="px-1">
                                                            <Split title="RIB" border value={client.rib} />
                                                            <Split title="Iban" border value={client.iban} />
                                                            <Split title="Titulaire" value={client.titulaire} />
                                                        </Accordion.Body>
                                                    </Accordion.Item>

                                                    <Accordion.Item eventKey="localisation" className="border-0 mb-3">
                                                        <Accordion.Header>Localisation</Accordion.Header>
                                                        <Accordion.Body className="px-1">
                                                            <Split title="GPS" value={`Lat : ${client.gps[0] || "N/C"} Lon : ${client.gps[1] || "N/C"}`} />
                                                        </Accordion.Body>
                                                    </Accordion.Item>

                                                    <Accordion.Item eventKey="echeance_comptable" className="border-0 mb-3">
                                                        <Accordion.Header>Liaison comptable</Accordion.Header>
                                                        <Accordion.Body className="px-1">
                                                            <Split title="Code export" border value={client?.liaison_comptable?.code_export} />
                                                            <Split title="Échéance" value="" />
                                                            <div className="p-3 pt-0">
                                                                <Split title="Nombre de jours" border value={client?.liaison_comptable?.echeance?.nombre_jours} />
                                                                {client?.liaison_comptable?.echeance?.fin_mois == true &&
                                                                    <Split title="Fin de mois" value="Oui" border />
                                                                }
                                                                {client?.liaison_comptable?.echeance?.fin_mois == false &&
                                                                    <>
                                                                        <Split title="Jour du mois" border value={client?.liaison_comptable?.echeance?.jour_du_mois} />
                                                                        <Split title="Fin de mois" value="Non" border />
                                                                    </>
                                                                }
                                                            </div>
                                                            <Split title="Solde" value="" />
                                                            <div className="p-3 pt-0">
                                                                <Split title="Date" border value={new Date(client?.liaison_comptable?.solde?.date).toLocaleString()} />
                                                                <Split title="Montant" border value={client?.liaison_comptable?.solde?.montant} />
                                                            </div>

                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </>
                                        }
                                        {openElement == "tags" &&
                                            <Tags folderId={props.folderId} client={client} setTags={(tags) => setTags(tags)} isClientLoading={getClientLoading} onTagChange={() => tabChange()} />
                                        }
                                        {openElement == "adresses" &&
                                            <Adresses folderId={props.folderId} client={client} isClientLoading={getClientLoading} onAdresseChange={() => tabChange()} />
                                        }
                                        {openElement == "interlocuteurs" &&
                                            <Interlocuteurs folderId={props.folderId} client={client} onInterlocuteurChange={() => tabChange()} />
                                        }
                                        {openElement == "factures" &&
                                            <Factures folderId={props.folderId} client={client} />
                                        }
                                        {openElement == "proformas" &&
                                            <Proformas folderId={props.folderId} client={client} />
                                        }
                                        {openElement == "abonnements" &&
                                            <Abonnements folderId={props.folderId} client={client} />
                                        }
                                        {openElement == "reglements" &&
                                            <Reglements showReglementForm={showReglementForm} folderId={props.folderId} client={client} onReglementChange={() => tabChange()} />
                                        }
                                        {openElement == "releve" &&
                                            <Releve folderId={props.folderId} client={client} />
                                        }


                                    </Col>
                                </Row>
                            </div>

                        </div>

                    </>

                )
            }
        </div>

    )

}

export default ClientDetails;